/* ToysDuo tema davranışları */
(function () {
  function init(root) {
    root = root || document;

    // Galeri: küçük resme tıklayınca ana görsel değişir
    root.querySelectorAll('[data-td-gallery]').forEach(function (gal) {
      if (gal.dataset.tdReady) return;
      gal.dataset.tdReady = '1';
      var main = gal.querySelector('.td-gal__main img');
      if (!main) return;
      gal.querySelectorAll('[data-td-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.src = btn.dataset.src;
          main.srcset = btn.dataset.srcset || '';
          main.alt = btn.dataset.alt || main.alt;
          gal.querySelectorAll('[data-td-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });

    // Adet seçici
    root.querySelectorAll('[data-td-qty]').forEach(function (box) {
      if (box.dataset.tdReady) return;
      box.dataset.tdReady = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.dataset.step === '+' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });

    // Varyant seçimi: fiyatı ve stok durumunu günceller
    root.querySelectorAll('[data-td-product]').forEach(function (wrap) {
      if (wrap.dataset.tdReady) return;
      wrap.dataset.tdReady = '1';
      var sel = wrap.querySelector('[data-td-variant]');
      if (!sel) return;
      var price = wrap.querySelector('[data-td-price]');
      var compare = wrap.querySelector('[data-td-compare]');
      var buttons = wrap.querySelectorAll('[data-td-buy]');
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        if (price) price.textContent = o.dataset.price;
        if (compare) { compare.textContent = o.dataset.compare || ''; compare.hidden = !o.dataset.compare; }
        var ok = o.dataset.available === 'true';
        buttons.forEach(function (b) { b.disabled = !ok; });
      });
    });

    // ---------- Ürün sayfası ----------
    root.querySelectorAll('[data-td-pm]').forEach(function (pm) {
      if (pm.dataset.tdReady) return;
      pm.dataset.tdReady = '1';

      // Galeri
      var track = pm.querySelector('[data-td-slides]');
      var slides = track ? [].slice.call(track.children) : [];
      var thumbs = [].slice.call(pm.querySelectorAll('[data-td-go]'));
      var cur = pm.querySelector('[data-td-cur]');
      function current() { return track ? Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) : 0; }
      function go(i) {
        if (!track || !slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function mark() {
        var i = current();
        if (cur) cur.textContent = i + 1;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var t = thumbs[i];
        if (t && t.parentElement) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
      if (track) {
        var tmr; track.addEventListener('scroll', function () { clearTimeout(tmr); tmr = setTimeout(mark, 60); }, { passive: true });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.tdGo, 10)); }); });
      var prev = pm.querySelector('[data-td-prev]'), next = pm.querySelector('[data-td-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });

      // Varyantlar
      var variants = [], str = { add: 'Sepete Ekle', soldout: 'Tükendi', unavailable: 'Bu seçenek yok' };
      try { variants = JSON.parse(pm.querySelector('[data-td-variants]').textContent); } catch (e) {}
      try { str = JSON.parse(pm.querySelector('[data-td-strings]').textContent); } catch (e) {}
      var idInput = pm.querySelector('[data-td-id]');
      var addBtn = pm.querySelector('[data-td-add]');
      var buyBtn = pm.querySelector('[data-td-buynow]');
      var barBtn = pm.querySelector('[data-td-baradd]');
      var optInputs = [].slice.call(pm.querySelectorAll('[data-td-opt]'));
      function selected() {
        var out = [];
        optInputs.forEach(function (i) { if (i.checked) out[parseInt(i.dataset.tdOpt, 10)] = i.value; });
        return out;
      }
      function setBtns(v) {
        var ok = !!(v && v.available);
        var label = !v ? str.unavailable : (v.available ? str.add : str.soldout);
        [addBtn, buyBtn, barBtn].forEach(function (b) { if (b) b.disabled = !ok; });
        if (addBtn) addBtn.querySelector('span').textContent = label;
        if (barBtn) barBtn.textContent = label;
      }
      function update() {
        var sel = selected();
        sel.forEach(function (val, n) { var o = pm.querySelector('[data-td-optval="' + n + '"]'); if (o) o.textContent = val; });
        var v = variants.filter(function (x) { return x.options.every(function (o, n) { return o === sel[n]; }); })[0];
        // Seçili diğer değerlerle mevcut olmayan seçenekleri soluklaştır
        optInputs.forEach(function (inp) {
          var n = parseInt(inp.dataset.tdOpt, 10);
          var test = sel.slice(); test[n] = inp.value;
          var hit = variants.some(function (x) { return x.available && x.options.every(function (o, k) { return o === test[k]; }); });
          inp.parentElement.classList.toggle('is-off', !hit);
        });
        setBtns(v);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        pm.querySelectorAll('[data-td-price]').forEach(function (p) { p.textContent = v.price; });
        var c = pm.querySelector('[data-td-compare]');
        if (c) { c.textContent = v.compare || ''; c.hidden = !v.compare; }
        var sale = pm.querySelector('[data-td-sale]'); if (sale) sale.hidden = !v.compare;
        if (v.media) {
          var idx = slides.findIndex(function (sl) { return sl.dataset.mediaId == v.media; });
          if (idx > -1) go(idx);
        }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      optInputs.forEach(function (i) { i.addEventListener('change', update); });
      if (optInputs.length) update();

      // Hemen satın al: sepete ekle ve ödeme sayfasına git
      if (buyBtn) buyBtn.addEventListener('click', function () {
        var form = pm.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        buyBtn.disabled = true; buyBtn.classList.add('is-busy');
        var fd = new FormData(form);
        var q = pm.querySelector('[data-td-qty] input');
        if (q) fd.set('quantity', q.value);
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (r) {
            if (r && r.status) { alertErr(r.description || r.message); buyBtn.disabled = false; return; }
            location.href = '/checkout';
          })
          .catch(function () { buyBtn.disabled = false; form.submit(); });
      });
      function alertErr(msg) {
        var w = pm.querySelector('.product-form__error-message-wrapper');
        if (!w) return;
        w.hidden = false; w.querySelector('.product-form__error-message').textContent = msg || 'Ürün sepete eklenemedi.';
      }

      // Mobil sabit çubuk
      var bar = pm.querySelector('[data-td-bar]');
      if (bar && addBtn) {
        var ticking = false;
        var check = function () {
          ticking = false;
          var on = addBtn.getBoundingClientRect().bottom < 0;
          bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (barBtn) barBtn.tabIndex = on ? 0 : -1;
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        window.addEventListener('resize', check);
        check();
        if (barBtn) barBtn.addEventListener('click', function () { addBtn.click(); });
      }
    });

    // Gizlenecek ürünler (ör. hediye kesesi ürünü) gridlerde görünmesin
    var hide = (window.TD_HIDE || []).filter(Boolean);
    if (hide.length) {
      root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var h = decodeURIComponent(a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0];
        if (hide.indexOf(h) === -1) return;
        var card = a.closest('.grid__item, .td-card, .predictive-search__list-item, .cart-drawer__collection');
        if (card) card.classList.add('td-hidden-card');
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
